import React, { Fragment, useState } from 'react';

import Card from 'components/Card';
import { useUpdateTimezoneLocationMutation, Timezone_Location_Enum } from 'types/generated/client';
import { useCurrentUser } from 'hooks/useCurrentUser';

import { SliderWrapper, SliderActive, SliderButton } from './styles';

export default function TimezoneSettings() {
  const { user } = useCurrentUser();
  const [updateTimezoneLocationMutation] = useUpdateTimezoneLocationMutation();

  const [isWallStreeTimeZone, setIsWallStreeTimeZone] = useState(
    user?.timezoneLocation === 'WALLSTREET',
  );

  const handleTimezoneUpdate = (timezoneLocation: Timezone_Location_Enum) => {
    setIsWallStreeTimeZone(timezoneLocation === Timezone_Location_Enum.Wallstreet);

    if (user?.id) {
      updateTimezoneLocationMutation({
        variables: { id: user?.id, timezoneLocation },
      });
    }
  };

  return (
    <Fragment>
      <div className="flex justify-between">
        <div className="styled-font mb-2 text-xl font-semibold">Timezone Details</div>
      </div>
      <Card>
        <div className="p-2">
          <div className="flex items-center justify-between">
            <div className="text-lg font-semibold">Timezone for Trades</div>
            <SliderWrapper customWidth={300}>
              <SliderActive tabs={2} activeTab={isWallStreeTimeZone ? 1 : 0} />
              <SliderButton
                tabs={2}
                onClick={() => handleTimezoneUpdate(Timezone_Location_Enum.Current)}
              >
                MY TIMEZONE
              </SliderButton>
              <SliderButton
                tabs={2}
                onClick={() => handleTimezoneUpdate(Timezone_Location_Enum.Wallstreet)}
              >
                WALL STREET TIMEZONE
              </SliderButton>
            </SliderWrapper>
          </div>
        </div>
      </Card>
    </Fragment>
  );
}
